import { useEffect } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";

const H = ({ children }) => (
  <h3 className="font-display mt-8 mb-2 text-xl tracking-tight text-[#1A1C19]">{children}</h3>
);

const P = ({ children }) => (
  <p className="text-base leading-relaxed text-[#3D403A]">{children}</p>
);

const Impressum = () => (
  <>
    <H>Angaben gemäß § 5 DDG</H>
    <P>
      Imbiss Tsolias Restaurant
      <br />
      Spandauer Straße 1
      <br />
      57072 Siegen
    </P>
    <H>Kontakt</H>
    <P>
      Telefon: <a href="tel:+4927121529" data-testid="impressum-phone-link" className="font-semibold text-[#4B7F94]">0271 21529</a>
      <br />
      E-Mail:{" "}
      <a href="mailto:petridisdimi@gmail.com" data-testid="impressum-email-link" className="font-semibold text-[#4B7F94]">
        petridisdimi@gmail.com
      </a>
    </P>
    <H>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H>
    <P>Betreiber des Imbiss Tsolias Restaurant, Anschrift wie oben.</P>
    <H>Haftung für Inhalte</H>
    <P>
      Die Inhalte dieser Seite wurden mit Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und Aktualität der
      Angaben — insbesondere Preise und Öffnungszeiten — kann keine Gewähr übernommen werden.
    </P>
  </>
);

const Datenschutz = () => (
  <>
    <H>1. Verantwortliche Stelle</H>
    <P>
      Imbiss Tsolias Restaurant, Spandauer Straße 1, 57072 Siegen, Telefon: 0271 21529, E-Mail:
      petridisdimi@gmail.com
    </P>
    <H>2. Erhebung von Daten auf dieser Website</H>
    <P>
      Diese Website verwendet keine Cookies, kein Tracking und keine Kontaktformulare. Es werden keine
      personenbezogenen Daten durch uns aktiv erhoben.
    </P>
    <H>3. Server-Log-Dateien</H>
    <P>
      Der Hosting-Anbieter (IONOS) erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien,
      die Ihr Browser übermittelt (Browsertyp, Betriebssystem, Referrer-URL, Uhrzeit der Anfrage, IP-Adresse). Diese
      Daten werden nicht mit anderen Datenquellen zusammengeführt. Grundlage ist Art. 6 Abs. 1 lit. f DSGVO.
    </P>
    <H>4. Google Fonts</H>
    <P>
      Zur einheitlichen Darstellung von Schriftarten werden Google Fonts geladen. Beim Aufruf der Seite baut Ihr
      Browser eine Verbindung zu Servern von Google auf, wobei Ihre IP-Adresse übermittelt wird. Anbieter: Google
      Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
    </P>
    <H>5. Kontaktaufnahme per Telefon oder E-Mail</H>
    <P>
      Bei Bestellungen oder Anfragen per Telefon oder E-Mail verarbeiten wir Ihre Angaben (z. B. Name,
      Telefonnummer) ausschließlich zur Bearbeitung Ihrer Bestellung bzw. Anfrage (Art. 6 Abs. 1 lit. b DSGVO).
    </P>
    <H>6. Ihre Rechte</H>
    <P>
      Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer
      personenbezogenen Daten sowie ein Beschwerderecht bei der zuständigen Aufsichtsbehörde.
    </P>
  </>
);

export const LegalOverlay = ({ page, onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
      className="fixed inset-0 z-[60] flex items-start justify-center overflow-y-auto bg-[#1A1C19]/50 px-4 py-10 backdrop-blur-sm"
      onClick={onClose}
      data-testid="legal-overlay"
    >
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.33, 1, 0.68, 1] }}
        className="relative w-full max-w-2xl rounded-2xl border border-[#E2E0D8] bg-[#F9F8F6] p-8 shadow-[0_32px_80px_rgba(26,28,25,0.25)] md:p-12"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          data-testid="legal-close-button"
          aria-label="Schließen"
          className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full border border-[#E2E0D8] bg-white/70 text-[#1A1C19] transition-colors duration-300 hover:bg-[#1A1C19] hover:text-[#F9F8F6]"
        >
          <X size={16} strokeWidth={1.5} />
        </button>
        <h2 className="font-display text-3xl font-normal tracking-tight text-[#1A1C19] md:text-4xl">
          {page === "impressum" ? "Impressum" : "Datenschutzerklärung"}
        </h2>
        <div className="mt-2">{page === "impressum" ? <Impressum /> : <Datenschutz />}</div>
      </motion.div>
    </motion.div>
  );
};
